import { TIMEOUT } from '@/app/_constants/fetch-config'

import { setUrlParams } from '../../_utils/set-url-params'

export async function getPriceRange(url: string | null) {
    if (!url) return null

    const controller = new AbortController()
    const timeoutId = setTimeout(() => controller.abort(), TIMEOUT)

    const finalUrl = setUrlParams(url)

    try {
        const response = await fetch(finalUrl, { signal: controller.signal })

        if (!response.ok) {
            throw new Error(`Error fetching price ranges. URL: ${finalUrl}. Status Code: ${response.status}`)
        }

        const result = await response.json()

        return result.data
    } catch (error) {
        clearTimeout(timeoutId)

        throw new Error(`Error fetching price ranges. URL: ${finalUrl}`)
    } finally {
        clearTimeout(timeoutId)
    }
}
